import * as React from 'react';
type Props = {
  className?: string;
};
export function NoOnion({ className }: Props) {
  return (
    <svg
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-NoOnion"
      className={className}
    >
      <g clipPath="url(#clip0_146_904)">
        <path
          d="M32.2523 15.4322C29.3318 15.5607 17.4392 14.3808 10.8854 26.3434C9.92045 28.5471 9.65917 30.995 10.1376 33.3527C11.5745 39.8831 21.5162 45.584 31.2475 45.1634C32.1121 45.1247 32.974 45.0389 33.8292 44.9065C34.6236 44.7663 45.5115 42.8387 49.5652 33.785C50.2661 32.2195 51.9016 28.6682 50.7334 24.8482C48.5488 17.9323 38.8411 15.1401 32.2523 15.4322Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M28.5959 15.4439C26.6896 17.6281 25.2609 20.1866 24.4019 22.9555C21.0724 33.8434 28.3973 43.6215 29.4253 44.9416"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M31.7266 15.6776C33.776 17.7366 35.3682 20.2047 36.3995 22.9206C40.3597 33.5982 33.6192 43.7851 32.6729 45.1169"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M36.0609 44.3458C43.923 37.6752 45.9323 27.8154 42.0888 21.6588C39.2617 17.1144 34.0048 15.8178 32.2524 15.4323"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M28.035 15.5841C26.306 16.0748 21.1659 17.757 18.6892 22.4884C15.2897 28.9136 17.9883 38.5982 26.3061 44.6846"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M26.3877 49.556L31.2942 45.1285"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M31.2944 45.1285V50.8528"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M31.5864 45.1752L36.2126 49.7313"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M30.0913 15.4907L31.3063 46.4369"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M41.82 16.9042C41.82 16.9042 33.327 14.0654 30.1377 9.1355C30.1377 9.1355 25.6048 15.5257 18.8408 18.1658"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M11.7852 52.4533L19.6356 42.8972"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M1.08399 29.9882C1.08399 24.1703 2.80926 18.4831 6.04152 13.6456C9.27378 8.80822 13.868 5.03789 19.2431 2.81147C24.6181 0.58505 30.5327 0.00254708 36.2388 1.13757C41.9449 2.27258 47.1863 5.07419 51.3002 9.18807C55.4141 13.302 58.2156 18.5434 59.3506 24.2495C60.4856 29.9556 59.9031 35.8702 57.6767 41.2452C55.4503 46.6203 51.6801 51.2144 46.8427 54.4466C42.0053 57.6789 36.318 59.4042 30.5001 59.4042C26.6367 59.4057 22.8107 58.6459 19.2411 57.1681C15.6715 55.6904 12.428 53.5236 9.69622 50.7918C6.96439 48.06 4.79778 44.8167 3.32004 41.2471C1.8423 37.6775 1.08245 33.8516 1.08399 29.9882"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M41.6914 16.6238L49.2148 7.58179"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_146_904">
          <rect
            width={60}
            height={60}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
